/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import logo from '../assets/images/logo.png'
import { Menu } from 'primereact/menu'
import { userActions } from '../_actions'

function HeaderComponent({ updateToolTip, isExpand, isLogout }) {
  const dispatch = useDispatch()
  const history = useHistory()
  const [toolTipName, setTooltipName] = useState('Collapse')
  useEffect(() => {
    setTooltipName(isExpand ? 'Collapse' : 'Expand')
  }, [isExpand])
  useEffect(() => {
    if (isLogout)
      logout()
  }, [isLogout])
  const logout = () => {
    dispatch(userActions.logout())
    history.push('/dashboard/login')
  }
  const items = [{
    items: [
      { label: 'Logout', icon: 'pi pi-fw pi-sign-out', command: () => { logout() } }]
  },
  ]
  const menu = useRef()
  const menuShow = (event) => {
    menu.current.toggle(event)
  }

  const ToggleMenu = () => {
    updateToolTip(isExpand ? false : true)
  }
  const [userName] = useState(userActions.getCurrentUserDetail().userName)
  return (
    <div className="header">
      <div className="sidebar--logoSec">
        <img src={logo} alt="logo" />
        <i id="toggleSideMenu" className="pi pi-align-justify collapesOpenIcon" data-toggle="tooltip" title={toolTipName} onClick={(event) => ToggleMenu(event)}></i>
      </div>
      <div className="header--wrapperRight">
        <div className="header--wrapperRight--userBtn">
          <p className="header--wrapperRight--userBtn--userInfo">Hello <span> {userName} </span></p>
          <Menu model={items} popup={true} ref={menu} id="popup_menu" />
          <span className="header--wrapperRight--userBtn--userTxt cursorPointer" onClick={(event) => menuShow(event)}>{userName ? userName.trim().substring(0, 1).toUpperCase() : 'W'}</span>
        </div>
      </div>
    </div>
  )
}
export default HeaderComponent
